document.addEventListener('DOMContentLoaded', function () {

  /* ---------- mobile nav ---------- */
  var menuToggle = document.getElementById('mobile-menu-toggle');
  var mobileNav = document.getElementById('mobile-nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
  }

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      if (drawer.classList.contains('open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  });

  /* ---------- AJAX add to cart ---------- */
  document.querySelectorAll('form[action^="/cart/add"], form.product-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('button[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.textContent = 'Adding...'; submitBtn.disabled = true; }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshCartDrawer();
      })
      .then(function () {
        if (submitBtn) { submitBtn.textContent = originalText; submitBtn.disabled = false; }
        openDrawer();
      })
      .catch(function (err) {
        console.error('Add to cart failed', err);
        if (submitBtn) { submitBtn.textContent = originalText; submitBtn.disabled = false; }
        // fall back to a normal form submit so the purchase still goes through
        form.submit();
      });
    });
  });

  function updateCartCount(count) {
    var badge = document.querySelector('.cart-count');
    var icon = document.getElementById('cart-icon');
    if (count > 0) {
      if (!badge && icon) {
        badge = document.createElement('span');
        badge.className = 'cart-count';
        icon.appendChild(badge);
      }
      if (badge) badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  function refreshCartDrawer() {
  return fetch(window.location.pathname + '?cart_refresh=' + Date.now())
    .then(function(res) {
      return res.text();
    })
    .then(function(html) {
      var temp = document.createElement('div');
      temp.innerHTML = html;

      var newDrawer = temp.querySelector('#cart-drawer');

      if (newDrawer && drawer) {
        drawer.innerHTML = newDrawer.innerHTML;
      }
    });
}
function refreshCartDrawer() {
  return fetch(window.location.pathname + '?cart_refresh=' + Date.now())
    .then(function(res) {
      return res.text();
    })
    .then(function(html) {
      var temp = document.createElement('div');
      temp.innerHTML = html;

      var newDrawer = temp.querySelector('#cart-drawer');

      if (newDrawer && drawer) {
        drawer.innerHTML = newDrawer.innerHTML;
      }
    });
}


// PASTE THE REMOVE CODE HERE 👇

document.addEventListener('click', function(e) {
  var removeLink = e.target.closest('a[href*="/cart/change"]');

  if (!removeLink) return;

  e.preventDefault();

  var url = new URL(removeLink.href);
  var line = url.searchParams.get('line');

  if (!line) return;

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      line: Number(line),
      quantity: 0
    })
  })
  .then(function(res) {
    return res.json();
  })
  .then(function(cart) {
    updateCartCount(cart.item_count);
    return refreshCartDrawer();
  })
  .catch(function(err) {
    console.error('Remove from cart failed', err);
  });
});

});
